// @flow

import React, { Component } from "react";
//prettier-ignore
import AbstractDialogTab, { type Props as AbstractDialogTabProps } from '../../../base/dialog/components/web/AbstractDialogTab';
import { translate } from "../../../base/i18n/functions";
import JitsiMeetJS from "../../../base/lib-jitsi-meet/_";
import { createLocalTrack } from "../../../base/lib-jitsi-meet/functions";
import logger from "../../../device-selection/logger";
import AudioInputPreview from "./AudioInputPreview";
import AudioOutputPreview from "./AudioOutputPreview";
import DeviceSelector from "../../../device-selection/components/DeviceSelector";
import VideoInputPreview from "../../../device-selection/components/VideoInputPreview";
import { connect as reactReduxConnect } from "../../../base/redux";
import SimpleReactValidator from "simple-react-validator";
import { getConferenceNameForTitle } from "../../../base/conference";
import { firebaseLogin } from "../../firebase/firebaseActions";
import Auth from "../../services/authService";
import { InviteViaMail, UpdateTopic, SentInvitationList } from "./actions";
import { ExtensionList, DefaultLobby, UpdateMeetingStatus } from "./../Meet/meet_actions";
import "react-select2-wrapper/css/select2.css";
import LoaderPage from "./../JitsiMeet/LoaderPage";
import __WaitingRoom from "./../../services/Chat";
import { Authorized_User } from "./../Call/call_actions";
import swal from "sweetalert";
import InviteMember from "./InviteMember";
import InviteViaEmail from "./InviteViaEmail";
import authService from "../../services/authService"; 
import { disconnect } from "../../../base/connection"; 
import InviteViaEmailPopup from "./InviteViaEmailPopup";

/**
 * The type of the React {@code Component} props of {@link DeviceSelection}.
 */
export type Props = {
    ...$Exact<AbstractDialogTabProps>,

    /**
     * All known audio and video devices split by type. This prop comes from
     * the app state.
     */
    availableDevices: Object,

    /**
     * Whether or not the audio selector can be interacted with. If true,
     * the audio input selector will be rendered as disabled. This is
     * specifically used to prevent audio device changing in Firefox, which
     * currently does not work due to a browser-side regression.
     */
    disableAudioInputChange: boolean,

    /**
     * True if device changing is configured to be disallowed. Selectors
     * will display as disabled.
     */
    disableDeviceChange: boolean,

    /**
     * If true, the audio meter will not display. Necessary for browsers or
     * configurations that do not support local stats to prevent a
     * non-responsive mic preview from displaying.
     */
    hideAudioInputPreview: boolean,

    /**
     * Whether or not the audio output source selector should display. If
     * true, the audio output selector and test audio link will not be
     * rendered.
     */
    hideAudioOutputSelect: boolean,

    /**
     * An optional callback to invoke after the component has completed its
     * mount logic.
     */
    mountCallback?: Function,

    /**
     * The id of the audio input device to preview.
     */
    selectedAudioInputId: string,

    /**
     * The id of the audio output device to preview.
     */
    selectedAudioOutputId: string,

    /**
     * The id of the video input device to preview.
     */
    selectedVideoInputId: string,

    /**
     * Invoked to obtain translated strings.
     */
    t: Function,
};

/**
 * The type of the React {@code Component} state of {@link DeviceSelection}.
 */
type State = {
    /**
     * Whether or not the audio permission was granted.
     */
    hasAudioPermission: boolean,

    /**
     * Whether or not the audio permission was granted.
     */
    hasVideoPermission: boolean,

    /**
     * The JitsiTrack to use for previewing audio input.
     */
    previewAudioTrack: ?Object,

    /**
     * The JitsiTrack to use for previewing video input.
     */
    previewVideoTrack: ?Object,

    /**
     * The error message from trying to use a video input device.
     */
    previewVideoTrackError: ?string,
};

/**
 * React {@code Component} for previewing audio and video input/output devices.
 *
 * @extends Component
 */
class DeviceSelection extends AbstractDialogTab<Props, State> {
    /**
     * Whether current component is mounted or not.
     *
     * In component did mount we start a Promise to create tracks and
     * set the tracks in the state, if we unmount the component in the meanwhile
     * tracks will be created and will never been disposed (dispose tracks is
     * in componentWillUnmount). When tracks are created and component is
     * unmounted we dispose the tracks.
     */
    _unMounted: boolean;

    /**
     * Initializes a new DeviceSelection instance.
     *
     * @param {Object} props - The read-only React Component props with which
     * the new instance is to be initialized.
     */
    constructor(props: Props) {
        super(props);

        this.state = {
            hasAudioPermission: false,
            hasVideoPermission: false,
            previewAudioTrack: null,
            previewVideoTrack: null,
            previewVideoTrackError: null,
            cameraPreview: true,
            audioDevice: false,
            cameraDevice: "",
            speakerDevice: "",
            __waitingRoomEnabled: false,
            __isMounted: false,
            __showLobby: false,
            members: [],
            email: "",
            isInvitedUser: true,
            topic: "",
            __RestrictedUser: false,
            __InviteMember: "",
            disabledMedia:false
        };
        this._unMounted = true;
        this.validator = new SimpleReactValidator();
    }

    /**
     * Generate the initial previews for audio input and video input.
     *
     * @inheritdoc
     */
    componentDidMount() {
        const { _meetDetail: { is_owner, room_name: __RoomID, topic , media ,meet_type,enableLobby }} = this.props; 
        const { customerID, firstname, lastname, email, app_picture } = Auth.getUserDetail(); // TO check customerID
        let isHost = customerID && customerID === is_owner ? true : false; // TO check is host logged in 
        if (!localStorage._isInvitedByHost) {
            this.setState({ 
                isInvitedUser: false ,
                __waitingRoomEnabled: enableLobby === "Y" ? true : false
            },()=>{  
                if(isHost){
                    this.setState({
                        disabledMedia : false,
                        cameraPreview : true,
                        audioDevice:true
                    },()=>{
                        localStorage.setItem("video_muted", false);
                        localStorage.setItem("audio_muted", false);
                    })
                }else { 
                    let audio = media && JSON.parse(media).audio_muted 
                    let video = media && JSON.parse(media).video_muted 
                    this.setState({
                        disabledMedia : meet_type === "scheduled" ? true : false,
                        cameraPreview : !video,
                        audioDevice : !audio
                    },()=>{
                        localStorage.setItem("video_muted", video);
                        localStorage.setItem("audio_muted", audio);
                        if(meet_type === "scheduled"){
                            alert("Your media settings has been set by host, you can change it after joining the meet.") 
                        } 
                    }
                ) 
            }
            }); 
        } else {
            let getType = localStorage._isInvitedByHost;     // direct join in meet during video call
            this.joinWithAudio({ target: { checked: true } });
            this.joinWithVideo({
                target: { checked: getType === "video" ? true : false },
            });
            localStorage.removeItem("_isInvitedByHost");
            this.submitBtn();
        } 
        this._unMounted = false; 
        let userDetails = Auth.getUserDetail();
        if (userDetails.type && userDetails.type === "C") {
            // if user is master user
            APP.store.dispatch(ExtensionList(0, true, "get-agent-sibling"));
        }
        Promise.all([
            this._createAudioInputTrack(this.props.selectedAudioInputId),
            this._createVideoInputTrack(this.props.selectedVideoInputId),
        ])
            .catch((err) =>
                logger.warn("Failed to initialize preview tracks", err)
            )
            .then(() => this.props.mountCallback && this.props.mountCallback()); 
        this.setState({ topic }, () => {
            if (isHost) {
                this.setState({ __isMounted: true });
                this.SendInvitationList();
            } else {
                __WaitingRoom
                    .fetch_if_ref_exists(`/WaitingRoom/${__RoomID}`, true)
                    .then((response) => {
                        if (
                            typeof response === "object" &&
                            Object.keys(response).length
                        ) {
                            let filterMembers = Object.values(response).filter(
                                (value) => value.email === email
                            );
                            if (!filterMembers.length) {
                                __WaitingRoom
                                    .update_ref_with_children(
                                        `/WaitingRoom/${__RoomID}/`,
                                        [
                                            ...response,
                                            {
                                                name: `${firstname} ${lastname}`.trim(),
                                                email,
                                                role: "member",
                                                join: false,
                                                approval: "",
                                                app_picture: app_picture ?? "",
                                            },
                                        ]
                                    )
                                    .then(() => {
                                        __WaitingRoom.fetch_ref_on_update(
                                            `/WaitingRoom/${__RoomID}`,
                                            this.__JoinOnAuthentication
                                        );
                                    });
                            } else {
                                this.setState({ __isMounted: true });
                            }
                        } else {
                            this.setState({ __isMounted: true });
                    }
                });
            }
        });
    }

    SendInvitationList = () => {
        const {
            _meetDetail: { uniquekey: meeting_code },
        } = this.props;
        APP.store.dispatch(SentInvitationList({ meeting_code }));
    };

    __JoinOnAuthentication = (__response) => {
        if (!__response instanceof Array) {
            return;
        }
        const { email } = Auth.getUserDetail();
        const { __showLobby } = this.state;
        const { _roomName: __RoomID } = this.props;
        if (!__response && __showLobby) {
            Authorized_User(false);
            this.setState({
                __showLobby: false,
                __isMounted: false,
                __RestrictedUser: true,
            });
        }
        let filterMembers = __response.filter((value) => value.email === email);
        if (filterMembers.length && filterMembers?.[0]?.join === true) {
            __WaitingRoom.callback_exit(`/WaitingRoom/${__RoomID}`);
            this.setState({ __showLobby: false, __isMounted: true }, () =>
                this.submitBtn()
            );
        } else if (
            filterMembers.length &&
            filterMembers?.[0]?.join === false &&
            filterMembers?.[0].approval === "R"
        ) {
            __WaitingRoom.callback_exit(`/WaitingRoom/${__RoomID}`);
            Authorized_User(false);
            this.setState({
                __showLobby: false,
                __isMounted: false,
                __RestrictedUser: true,
            });
        } else if (
            filterMembers.length &&
            filterMembers?.[0]?.join === false &&
            filterMembers?.[0].approval === ""
        ) {
            this.setState({ __showLobby: true, __isMounted: true });
            __WaitingRoom.set_on_disconnect(
                `/WaitingRoom/${__RoomID}/`,
                _.differenceBy(__response, filterMembers)
            );
        }
    };

    /**
     * If user is moderator/host the scenario will work
     *
     * @param {Component} __WaitingRoom - To perform actions with firebase.
     * @returns {void}
     */

    __EnableWaitingRoom = () => {
        const { __waitingRoomEnabled } = this.state;
        this.setState({ __waitingRoomEnabled: !__waitingRoomEnabled }, () => {
            DefaultLobby(this.state.__waitingRoomEnabled);
        });
    };

    componentDidUpdate(prevProps, prevState) {
        const { default_lobby: __old_waitingRoomEnabled } = this.props;
        const { default_lobby: __waitingRoomEnabled } = this.props;
        if (__waitingRoomEnabled && __old_waitingRoomEnabled === false) {
            this.setState({ __waitingRoomEnabled });
        }
        const { previewAudioTrack, previewVideoTrack } = prevState;
        if (
            (!previewAudioTrack && this.state.previewAudioTrack) ||
            (!previewVideoTrack && this.state.previewVideoTrack)
        ) {
            Promise.all([
                JitsiMeetJS.mediaDevices.isDevicePermissionGranted("audio"),
                JitsiMeetJS.mediaDevices.isDevicePermissionGranted("video"),
            ]).then((r) => {
                const [hasAudioPermission, hasVideoPermission] = r;

                this.setState({
                    hasAudioPermission,
                    hasVideoPermission,
                });
            });
        }

        if (
            prevProps.selectedAudioInputId !== this.props.selectedAudioInputId
        ) {
            this._createAudioInputTrack(this.props.selectedAudioInputId);
        }

        if (
            prevProps.selectedVideoInputId !== this.props.selectedVideoInputId
        ) {
            this._createVideoInputTrack(this.props.selectedVideoInputId);
        }
    }

    joinWithVideo = (e) => { 
        if (e.target.checked) { 
            this.setState({ cameraPreview: true },()=>{
                localStorage.setItem("video_muted", false);
            });
        } else { 
            this.setState({ cameraPreview: false },()=>{
                localStorage.setItem("video_muted", true);
            });
        }
    };

    joinWithAudio = (e) => {
        if (e.target.checked) { 
            this.setState({ audioDevice: true },()=>{localStorage.setItem("audio_muted", false);});
        } else {
            this.setState({ audioDevice: false },()=>{ localStorage.setItem("audio_muted", true);});
        }
    };

    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    /**
     * Ensure preview tracks are destroyed to prevent continued use.
     *
     * @inheritdoc
     */
    componentWillUnmount() {
        this._unMounted = true;
        this._disposeAudioInputPreview();
        this._disposeVideoInputPreview();
    }

    copyMeetingDetails = () => {
        // prettier-ignore
        const text = location.href.replace(location.search,"");
        if (text) {
            navigator.clipboard
                .writeText(text)
                .then(() => {
                    alert(`Copied the text: ${text}`);
                })
                .catch((error) => {
                    console.error(`Copy failed!`, error);
                });
        }
    };

    EndMeeting = async() => { 
        const { _meetDetail: {uniquekey}} = this.props;
        let response = await APP.store.dispatch(UpdateMeetingStatus({status:"Completed",uniquekey})) 
        if(response === 1){
            authService.logout();
            window.close();
            SignoutUser();
            APP.store.dispatch(disconnect()); 
        } 
    };

    inviteMembers = () => {
        const { members } = this.state;
        const {
            _meetDetail: { room_name: meetingID },
        } = this.props;
        if (members.length === 0) {
            swal({
                text: "Please select email to send invitation!",
                icon: "error",
                buttons: true,
                dangerMode: true,
            });
            return null;
        }
        APP.store.dispatch(
            InviteViaMail({
                email: members.map((val) => val.label),
                meetingID,
                link:location.href.replace(location.search,""),
            })
        );
    };

    handleDelete = (emailToDelete) => () => {
        const { members } = this.state;
        this.setState({
            members: members.filter(
                (response) => response.key !== emailToDelete.key
            ),
        });
    };

    handleKeyDown = (evt) => {
        const { members } = this.state;
        if (evt.key === "Backspace" && evt.target.value === "") {
            this.setState(
                { email: members?.[members.length - 1]?.label ?? "" },
                () => {
                    members.pop();
                    this.setState({ members });
                }
            );
        }
        if (["Enter", "Tab", ","].includes(evt.key)) {
            evt.preventDefault();
            if (!this.validator.allValid()) {
                this.validator.showMessages();
                this.forceUpdate();
                return false;
            }
            const { email } = this.state;
            var value = email.trim();
            if (value && !this.isInList(value)) {
                this.setState({
                    members: [
                        ...members,
                        { key: members.length, label: value },
                    ],
                });
            }
            this.setState({ email: "" });
        }
    };

    handleChange = (evt) => {
        this.setState({ email: evt.target.value });
    };

    isInList = (email) => {
        const { members } = this.state;
        return members.filter((list) => list.label === email).length;
    };

    render() {
        // prettier-ignore
        const { _meetDetail: { host_name, is_owner, uniquekey, room_name, meet_type }, extension_list, invitation_list } = this.props; 

        console.log("Device selector meet",this.props)
        // prettier-ignore
        const { isInvitedUser, cameraPreview, previewVideoTrackError, previewVideoTrack, previewAudioTrack, audioDevice, __waitingRoomEnabled, members, topic, __isMounted, __showLobby, email, __RestrictedUser, __InviteMember ,disabledMedia  } = this.state;
        const { uuid: localId, customerID, type } = Auth.getUserDetail();
        const isPrivateSession =
            location.pathname.includes(localId) && localId !== "";
        const deviceParams = this.DeviceConfigs()?.[0];
        let isHost = customerID && customerID === is_owner ? true : false; 

        if (isInvitedUser || !__isMounted || __RestrictedUser) {
            return <LoaderPage type={__RestrictedUser ? "unauthorized" : ""} />;
        }
        return (
            <>
                {isHost ? (
                    <div className="host-page-section">
                    
                        {
                            __InviteMember === "guest" && (
                                <InviteViaEmailPopup   {...{
                                    uniquekey,
                                    show: __InviteMember === "guest",
                                    handleClose: () => {
                                        this.setState({ __InviteMember: "" });
                                    },
                                }} />
                            )
                        }
                       
                        {/* <InviteViaEmail
                            {...{
                                uniquekey,
                                show: __InviteMember === "guest",
                                handleClose: () => {
                                    this.setState({ __InviteMember: "" });
                                },
                            }}
                        /> */}
                        <InviteMember
                            {...{
                                meeting_code: uniquekey,
                                room_name,
                                topic,
                                extension_list,
                                show: __InviteMember === "member",
                                meet_type,
                                handleClose: () => {
                                    this.setState({ __InviteMember: "" });
                                },
                                SendInvitationList: this.SendInvitationList,
                            }}
                        />
                        <div className="host-text-side">
                            <h3>Your meeting is ready!</h3>
                            <h5>
                                This meeting will not expire and you can enjoy
                                unlimited calls.
                            </h5>
                            <div className="form-group">
                                <label>what is this meeting about?</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="topic"
                                    value={topic}
                                    placeholder="Meeting Topic"
                                    onChange={(e) =>
                                        this.setState({ topic: e.target.value })
                                    }
                                />
                            </div>
                            <div className="form-group">
                                <label>share link and invite others</label>
                                <div className="copy-link">
                                    <input
                                        className="form-control invite-link-control"
                                        type="text"
                                        value={location.href.replace(
                                            location.search,
                                            ""
                                        )}
                                        onChange={(e) => e.preventDefault()}
                                    />
                                    <img
                                        src="public/assets/images/copy.svg"
                                        alt="1"
                                        onClick={this.copyMeetingDetails}
                                    />
                                </div>
                            </div>
                            {type && type === "C" && (
                                <div className="form-group search-group">
                                    <div
                                        className="search-input"
                                        onClick={() => {
                                            this.setState({
                                                __InviteMember: "member",
                                            });
                                        }}
                                    >
                                        <img
                                            src="public/assets/images/search-ico.svg"
                                            alt="1"
                                        />
                                        <input
                                            class="form-control"
                                            type="text"
                                            disabled
                                            value={
                                                invitation_list instanceof Array
                                                    ? invitation_list
                                                          .map(
                                                              (val) => val.name
                                                          )
                                                          .toString()
                                                    : ""
                                            }
                                        />
                                    </div>
                                    <a
                                        href={void 0}
                                        onClick={() => {
                                            this.setState({
                                                __InviteMember: "guest",
                                            });
                                        }}
                                        className="btn btn-orange"
                                    >
                                        Invite via Email
                                    </a>
                                </div>
                            )}
                            <div className="form-group mb-0">
                                <label className="mb-0">go to meeting</label>
                            </div>
                            <div className="form-group go-meeting-group">
                                <div className="pause-room">
                                    <h6>
                                        {" "}
                                        <img
                                            src="public/assets/images/lock.svg"
                                            alt="1"
                                        />{" "}
                                        Pause Room
                                    </h6>
                                    <label className="switch ml-4 camera-preview">
                                        <input
                                            type="checkbox"
                                            checked={__waitingRoomEnabled}
                                            onChange={this.__EnableWaitingRoom}
                                        />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <a
                                    href={void 0}
                                    className="btn btn-start-meet"
                                    onClick={(e) => this.submitBtn(e, "host")}
                                >
                                    Start Meeting
                                </a>
                            </div>
                            <div className="form-group end-call-group">
                                <a
                                    href={void 0}
                                    onClick={this.EndMeeting}
                                    className="btn btn-red"
                                >
                                    End Meeting
                                </a>
                            </div>
                        </div>
                        <div className="host-video-side">
                            <a href={void 0} className="device-setting-logo">
                                <img
                                    src="public/assets/images/loader-logo.svg"
                                    alt="1"
                                />
                            </a>
                            <div className="video-settings-box">
                                <div className="video-settings-box-inner">
                                    <div className="device-setting-tool">
                                        <span className="host-switch">
                                            <img
                                                src="public/assets/images/host-mic.svg"
                                                alt="1"
                                                className="host-mice-ico"
                                            />
                                            <label className="switch ml-3 camera-preview">
                                                <input
                                                    type="checkbox"
                                                    checked={audioDevice}
                                                    onChange={(e) =>
                                                        this.joinWithAudio(e)
                                                    } 
                                                />
                                                <span className="slider round" />
                                            </label>
                                        </span>
                                        <span className="host-switch">
                                            <img
                                                src="public/assets/images/host-video-ico.svg"
                                                alt="1"
                                                className="host-video-ico"
                                            />
                                            <label className="switch ml-3 camera-preview">
                                                <input
                                                    type="checkbox"
                                                    checked={cameraPreview}
                                                    onChange={(e) =>
                                                        this.joinWithVideo(e)
                                                    }
                                                />
                                                <span className="slider round" />
                                            </label>
                                        </span>
                                    </div>
                                    {cameraPreview ? (
                                        <VideoInputPreview
                                            error={previewVideoTrackError}
                                            track={previewVideoTrack}
                                        />
                                    ) : (
                                        <>
                                            <img
                                                className="no-video-img"
                                                src="public/assets/images/camera-bg.svg"
                                                alt="1"
                                            />
                                            <p>No Preview Available...</p>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : __showLobby ? (
                    <div class="lobby-screen-div">
                        <a className="loader-logo">
                            {" "}
                            <img
                                src="public/assets/images/loader-logo.svg"
                                alt="1"
                            />
                        </a>
                        <h3 className="lobby-page-title">
                            {`${host_name} is the meeting host and will let you in soon`}{" "}
                        </h3>
                        <p>Please wait...</p>

                        {/* video box */}
                        <div className="lobby-video-box">
                            <div className="lobby-video-box-inner">
                                {cameraPreview ? (
                                    <VideoInputPreview
                                        error={previewVideoTrackError}
                                        track={previewVideoTrack}
                                    />
                                ) : (
                                    <>
                                        <img
                                            className="no-video-img"
                                            src="public/assets/images/camera-bg.svg"
                                            alt="1"
                                        />
                                        <p>Preview not available...</p>
                                    </>
                                )}
                            </div>
                        </div>
                        {/* settings */}
                        <div className="lobby-setting-tool">
                            <span className="lobby-switch">
                                <img
                                    src="public/assets/images/meet-mice.svg"
                                    className="lobby-mice-ico"
                                    alt="1"
                                />
                                <label className="switch ml-3 camera-preview">
                                    <input
                                        type="checkbox"
                                        checked={audioDevice}
                                        onChange={(e) => this.joinWithAudio(e)}
                                        disabled={disabledMedia}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </span>
                            <span className="lobby-switch">
                                <img
                                    className="lobby-video-ico"
                                    src="public/assets/images/meet-video-ico.svg"
                                    alt="1"
                                />
                                <label className="switch ml-3 camera-preview">
                                    <input
                                        type="checkbox"
                                        checked={cameraPreview}
                                        onChange={(e) => this.joinWithVideo(e)}
                                        disabled={disabledMedia}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </span>
                            <a
                                href={void 0}
                                className="end-lobby-btn"
                                onClick={this.EndMeeting}
                            >
                                End
                            </a>
                        </div>
                    </div>
                ) : (
                    <div className="new-device-settings">
                        <a href={void 0} className="device-setting-logo">
                            <img
                                src="public/assets/images/loader-logo.svg"
                                alt="1"
                            />
                        </a>
                        <h3>
                            {isPrivateSession
                                ? "Video Call"
                                : `You are about to Join a meeting with Host, @${host_name}`}
                        </h3>
                        <div className="video-settings-box">
                            <div className="video-settings-box-inner">
                                {cameraPreview ? (
                                    <VideoInputPreview
                                        error={previewVideoTrackError}
                                        track={previewVideoTrack}
                                    />
                                ) : (
                                    <>
                                        <img
                                            className="no-video-img"
                                            src="public/assets/images/camera-bg.svg"
                                            alt="1"
                                        />
                                        <p>Preview not available...</p>
                                    </>
                                )}
                                <div className="device-setting-tool">
                                    <a
                                        href={void 0}
                                        className="connect-video"
                                        onClick={() =>
                                            $("#video-device-selection").modal(
                                                "show"
                                            )
                                        }
                                    >
                                        <img
                                            src="public/assets/images/connect-video-setting.svg"
                                            alt="1"
                                        />
                                        Connect to video system
                                    </a>
                                    <span className="dropdown">
                                        <img
                                            src="public/assets/images/audio-setting.svg"
                                            alt="1"
                                        />
                                        <a
                                            className=" dropdown-toggle"
                                            id="menu1"
                                            data-toggle="dropdown"
                                        >
                                            {
                                                (
                                                    previewAudioTrack?.track
                                                        ?.label ??
                                                    "No Mic Available"
                                                ).split("(")[0]
                                            }
                                            <span className="caret"></span>
                                        </a>
                                        <ul
                                            className="dropdown-menu"
                                            role="menu"
                                            aria-labelledby="menu1"
                                        >
                                            <a
                                                href={void 0}
                                                className="dropdown"
                                            ></a>
                                            <li role="presentation">
                                                {deviceParams?.devices ? (
                                                    deviceParams.devices.map(
                                                        (value) => {
                                                            const {
                                                                deviceId,
                                                                label,
                                                            } = value;
                                                            return (
                                                                <a
                                                                    role="menuitem"
                                                                    className={
                                                                        deviceParams.selectedDeviceId &&
                                                                        deviceId ===
                                                                            deviceParams.selectedDeviceId
                                                                            ? "active"
                                                                            : ""
                                                                    }
                                                                    href={
                                                                        void 0
                                                                    }
                                                                    onClick={() =>
                                                                        super._onChange(
                                                                            {
                                                                                selectedAudioInputId:
                                                                                    deviceId,
                                                                            }
                                                                        )
                                                                    }
                                                                >
                                                                    {label}
                                                                </a>
                                                            );
                                                        }
                                                    )
                                                ) : (
                                                    <a
                                                        role="menuitem"
                                                        href={void 0}
                                                        onClick={(e) =>
                                                            e.preventDefault()
                                                        }
                                                    >
                                                        null
                                                    </a>
                                                )}
                                            </li>
                                        </ul>
                                    </span>
                                    <a
                                        href={void 0}
                                        className="connect-video"
                                        onClick={() =>
                                            $("#audio-device-selection").modal(
                                                "show"
                                            )
                                        }
                                    >
                                        <img
                                            src="public/assets/images/device-setting.svg"
                                            alt="1"
                                        />
                                        Test speaker and microphone
                                    </a>
                                </div>
                                <div className="device-bottom-tools">
                                    <span className="switch-span video-meet-ico">
                                        <img
                                            src="public/assets/images/meet-video-ico.svg"
                                            alt="1"
                                        />
                                        <label className="switch ml-2 camera-preview">
                                            <input
                                                type="checkbox"
                                                checked={cameraPreview}
                                                onChange={(e) =>
                                                    this.joinWithVideo(e)
                                                }
                                                disabled={disabledMedia}
                                            />
                                            <span className="slider round"></span>
                                        </label>
                                    </span>
                                    <span className="switch-span meet-mic-ico">
                                        <img
                                            src="public/assets/images/meet-mice.svg"
                                            alt="1"
                                        />
                                        <label className="switch ml-2">
                                            <input
                                                type="checkbox"
                                                checked={audioDevice}
                                                onChange={(e) =>
                                                    this.joinWithAudio(e)
                                                }
                                                disabled={disabledMedia}
                                            />
                                            <span className="slider round"></span>
                                        </label>
                                    </span>
                                    <a
                                        href={void 0}
                                        className="btn btn-join-meet"
                                        onClick={this.submitBtn}
                                    >
                                        Join meeting
                                    </a>
                                </div>
                            </div>
                        </div>
                        {this.PopupModals("video", "video-device-selection")}
                        {this.PopupModals("audio", "audio-device-selection")}
                    </div>
                )}
            </>
        );
    }

    submitBtn = async (event, isHost = "") => {
        if (event) {
            event.preventDefault();
        }
        const { _roomName, _meetDetail } = this.props;
        const { topic, __waitingRoomEnabled } = this.state;
        const { room_name: __RoomID } = _meetDetail;
        const { firstname, lastname, email, app_picture } =
            Auth.getUserDetail();

        this.setState({ __isMounted: false }, () => {
            if (isHost === "host") {
                if (__waitingRoomEnabled) {
                    __WaitingRoom.add_ref_with_children(
                        `/WaitingRoom/${__RoomID}/`,
                        [
                            {
                                name: `${firstname} ${lastname}`.trim(),
                                email,
                                role: "moderator",
                                join: true,
                                approval: "Y",
                                app_picture: app_picture ?? "",
                            },
                        ]
                    );
                } else {
                    __WaitingRoom.remove_ref_data(`/WaitingRoom/${__RoomID}`);
                }
                __WaitingRoom.remove_on_disconnect(`/WaitingRoom/${__RoomID}`);
                APP.store.dispatch(
                    UpdateTopic({ topic, room_name: _roomName })
                );
                APP.store.dispatch({
                    type: "MEETING_DETAILS",
                    payload: { ..._meetDetail, topic },
                });
            }
            document.querySelector("#joinModal").click();
        });
    };

    /**
     * Creates the JitiTrack for the audio input preview.
     *
     * @param {string} deviceId - The id of audio input device to preview.
     * @private
     * @returns {void}
     */
    _createAudioInputTrack(deviceId) {
        return this._disposeAudioInputPreview()
            .then(() => createLocalTrack("audio", deviceId))
            .then((jitsiLocalTrack) => {
                if (this._unMounted) {
                    jitsiLocalTrack.dispose();

                    return;
                }

                this.setState({
                    previewAudioTrack: jitsiLocalTrack,
                });
            })
            .catch(() => {
                this.setState({
                    previewAudioTrack: null,
                });
            });
    }

    /**
     * Creates the JitiTrack for the video input preview.
     *
     * @param {string} deviceId - The id of video device to preview.
     * @private
     * @returns {void}
     */
    _createVideoInputTrack(deviceId) {
        return this._disposeVideoInputPreview()
            .then(() => createLocalTrack("video", deviceId))
            .then((jitsiLocalTrack) => {
                if (!jitsiLocalTrack) {
                    return Promise.reject();
                }

                if (this._unMounted) {
                    jitsiLocalTrack.dispose();

                    return;
                }

                this.setState({
                    previewVideoTrack: jitsiLocalTrack,
                    previewVideoTrackError: null,
                });
            })
            .catch(() => {
                this.setState({
                    previewVideoTrack: null,
                    previewVideoTrackError: this.props.t(
                        "deviceSelection.previewUnavailable"
                    ),
                });
            });
    }

    /**
     * Utility function for disposing the current audio input preview.
     *
     * @private
     * @returns {Promise}
     */
    _disposeAudioInputPreview(): Promise<*> {
        return this.state.previewAudioTrack
            ? this.state.previewAudioTrack.dispose()
            : Promise.resolve();
    }

    /**
     * Utility function for disposing the current video input preview.
     *
     * @private
     * @returns {Promise}
     */
    _disposeVideoInputPreview(): Promise<*> {
        return this.state.previewVideoTrack
            ? this.state.previewVideoTrack.dispose()
            : Promise.resolve();
    }

    /**
     * Creates a DeviceSelector instance based on the passed in configuration.
     *
     * @private
     * @param {Object} deviceSelectorProps - The props for the DeviceSelector.
     * @returns {ReactElement}
     */
    _renderSelector(deviceSelectorProps) {
        const { cameraPreview } = this.state;
        const TranslatedLabels = {
            "settings.selectCamera": "Camera",
            "settings.selectAudioOutput": "Audio Output",
            "settings.selectMic": "Microphone",
        };
        return (
            <div className="form-group" key={deviceSelectorProps.label}>
                <div className="device-selector-label">
                    {TranslatedLabels[deviceSelectorProps.label]}
                </div>
                {deviceSelectorProps.label === "settings.selectCamera" && (
                    <div className="form-group d-flex align-items-center av-switch">
                        <label className="switch mr-2">
                            <input
                                type="checkbox"
                                checked={cameraPreview}
                                onChange={(e) => this.joinWithVideo(e)}
                            />
                            <span className="slider round"></span>
                        </label>
                        Enable Camera/Video
                    </div>
                )}
                {deviceSelectorProps.label !== "settings.selectCamera" && (
                    <DeviceSelector {...deviceSelectorProps} />
                )}
                {deviceSelectorProps.label === "settings.selectCamera" &&
                    cameraPreview && (
                        <DeviceSelector {...deviceSelectorProps} />
                    )}
            </div>
        );
    }

    /**
     * Creates DeviceSelector instances for video output, audio input, and audio
     * output.
     *
     * @private
     * @returns {Array<ReactElement>} DeviceSelector instances.
     */
    _renderSelectors() {
        const { availableDevices } = this.props;
        const { hasAudioPermission, hasVideoPermission } = this.state;

        const configurations = [
            {
                devices: availableDevices.audioInput,
                hasPermission: hasAudioPermission,
                icon: "icon-microphone",
                isDisabled:
                    this.props.disableAudioInputChange ||
                    this.props.disableDeviceChange,
                key: "audioInput",
                label: "settings.selectMic",
                onSelect: (selectedAudioInputId) =>
                    super._onChange({ selectedAudioInputId }),

                selectedDeviceId: this.state.previewAudioTrack
                    ? this.state.previewAudioTrack.getDeviceId()
                    : null,
            },
            !this.props.hideAudioOutputSelect
                ? {
                      devices: availableDevices.audioOutput,
                      hasPermission: hasAudioPermission || hasVideoPermission,
                      icon: "icon-volume-1",
                      isDisabled: this.props.disableDeviceChange,
                      key: "audioOutput",
                      label: "settings.selectAudioOutput",
                      onSelect: (selectedAudioOutputId) =>
                          super._onChange({ selectedAudioOutputId }),
                      selectedDeviceId:
                          this.props.selectedAudioOutputId === undefined
                              ? "default"
                              : this.props.selectedAudioOutputId,
                  }
                : "",
        ];

        return configurations.map((config) => this._renderSelector(config));
    }

    _renderVideoSelectors() {
        const { availableDevices } = this.props;
        const { hasVideoPermission } = this.state;

        const configurations = [
            {
                devices: availableDevices.videoInput.filter(
                    (v, i, a) =>
                        a.findIndex((t) => t.deviceId === v.deviceId) === i
                ),
                hasPermission: hasVideoPermission,
                icon: "icon-camera",
                isDisabled: this.props.disableDeviceChange,
                key: "videoInput",
                label: "settings.selectCamera",
                onSelect: (selectedVideoInputId) => {
                    super._onChange({ selectedVideoInputId });
                },
                selectedDeviceId: this.state.previewVideoTrack
                    ? this.props.selectedVideoInputId === "N" ||
                      this.props.selectedVideoInputId === undefined
                        ? "N"
                        : this.state.previewVideoTrack.getDeviceId()
                    : null,
                selectedDeviceId: this.state.previewVideoTrack
                    ? this.state.previewVideoTrack.getDeviceId()
                    : null,
            },
        ];

        return configurations.map((config) => this._renderSelector(config));
    }

    DeviceConfigs = () => {
        const {
            availableDevices,
            disableAudioInputChange,
            disableDeviceChange,
            selectedAudioOutputId,
            selectedVideoInputId,
        } = this.props;
        const {
            hasVideoPermission,
            hasAudioPermission,
            previewAudioTrack,
            hideAudioOutputSelect,
            previewVideoTrack,
        } = this.state;
        const configurations = [
            {
                devices: availableDevices.audioInput,
                hasPermission: hasAudioPermission,
                icon: "icon-microphone",
                isDisabled: disableAudioInputChange || disableDeviceChange,
                key: "audioInput",
                label: "settings.selectMic",
                onSelect: (selectedAudioInputId) =>
                    super._onChange({ selectedAudioInputId }),
                selectedDeviceId: previewAudioTrack
                    ? previewAudioTrack.getDeviceId()
                    : null,
            },
            {
                devices: availableDevices.videoInput.filter(
                    (v, i, a) =>
                        a.findIndex((t) => t.deviceId === v.deviceId) === i
                ),
                hasPermission: hasVideoPermission,
                icon: "icon-camera",
                isDisabled: disableDeviceChange,
                key: "videoInput",
                label: "settings.selectCamera",
                onSelect: (selectedVideoInputId) => {
                    super._onChange({ selectedVideoInputId });
                },
                selectedDeviceId: previewVideoTrack
                    ? selectedVideoInputId === "N" ||
                      selectedVideoInputId === undefined
                        ? "N"
                        : previewVideoTrack.getDeviceId()
                    : null,
                selectedDeviceId: previewVideoTrack
                    ? previewVideoTrack.getDeviceId()
                    : null,
            },
            !hideAudioOutputSelect
                ? {
                      devices: availableDevices.audioOutput,
                      hasPermission: hasAudioPermission || hasVideoPermission,
                      icon: "icon-volume-1",
                      isDisabled: disableDeviceChange,
                      key: "audioOutput",
                      label: "settings.selectAudioOutput",
                      onSelect: (selectedAudioOutputId) =>
                          super._onChange({ selectedAudioOutputId }),
                      selectedDeviceId:
                          selectedAudioOutputId === undefined
                              ? "default"
                              : selectedAudioOutputId,
                  }
                : "",
        ];
        return configurations;
    };

    PopupModals = (type, id) => {
        const { cameraDevice, speakerDevice, previewAudioTrack } = this.state;
        const {
            hideAudioInputPreview,
            selectedAudioOutputId,
            hideAudioOutputSelect,
            nxatel_call: { authorized_user },
        } = this.props;
        const VideodeviceParams = this.DeviceConfigs()?.[1];
        const AudiodeviceParams = !hideAudioOutputSelect
            ? this.DeviceConfigs()?.[2]
            : {};
        return (
            <div
                className="modal fade"
                id={id}
                tabindex="-1"
                role="dialog"
                aria-labelledby={`Modal_${id}`}
                aria-hidden="true"
            >
                <div className="modal-dialog device-selection-settings" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id={`Modal_${id}`}>
                                {type === "video"
                                    ? "Camera settings"
                                    : "Speaker and microphone testing"}
                            </h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {type === "video" && (
                                <div className="form-group">
                                    <label>Camera</label>
                                    <select
                                        name="camera-device"
                                        className="form-control"
                                        value={cameraDevice}
                                        onChange={(e) =>
                                            super._onChange({
                                                selectedVideoInputId:
                                                    e.target.value,
                                            })
                                        }
                                    >
                                        {VideodeviceParams &&
                                        VideodeviceParams.selectedDeviceId ? (
                                            VideodeviceParams.devices.map(
                                                (value, key) => {
                                                    const { deviceId, label } =
                                                        value;
                                                    return (
                                                        <option
                                                            key={`video_${key}`}
                                                            value={deviceId}
                                                        >
                                                            {label}
                                                        </option>
                                                    );
                                                }
                                            )
                                        ) : (
                                            <option>
                                                No camera available...
                                            </option>
                                        )}
                                    </select>
                                </div>
                            )}
                            {type === "audio" && (
                                <>
                                    <div className="playsound">
                                        <div className="row">
                                            <div className="col-md-9">
                                                <small className="micro-text">
                                                    Microphone Test
                                                </small>
                                                {!hideAudioInputPreview && (
                                                    <AudioInputPreview
                                                        track={
                                                            previewAudioTrack
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <div className="col-md-3 pl-0">
                                                <small className="micro-text">
                                                    &nbsp;
                                                </small>
                                                {!hideAudioOutputSelect && (
                                                    <AudioOutputPreview
                                                        deviceId={
                                                            selectedAudioOutputId
                                                        }
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="playsound">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Speaker</label>
                                                    <select
                                                        name="speaker-device"
                                                        className="form-control"
                                                        value={speakerDevice}
                                                        onChange={(e) => {
                                                            super._onChange({
                                                                selectedAudioOutputId:
                                                                    e.target
                                                                        .value,
                                                            });
                                                            this.setState({
                                                                speakerDevice:
                                                                    e.target
                                                                        .value,
                                                            });
                                                        }}
                                                    >
                                                        {AudiodeviceParams &&
                                                        AudiodeviceParams.selectedDeviceId ? (
                                                            AudiodeviceParams.devices.map(
                                                                (
                                                                    value,
                                                                    key
                                                                ) => {
                                                                    const {
                                                                        deviceId,
                                                                        label,
                                                                    } = value;
                                                                    return (
                                                                        <option
                                                                            key={`video_${key}`}
                                                                            value={
                                                                                deviceId
                                                                            }
                                                                        >
                                                                            {
                                                                                label
                                                                            }
                                                                        </option>
                                                                    );
                                                                }
                                                            )
                                                        ) : (
                                                            <option>
                                                                No speaker
                                                                available...
                                                            </option>
                                                        )}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-orange"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}

function _mapStateToProps(state) {
    const {
        meeting_details: _meetDetail,
        extension_list,
        default_lobby,
    } = state["features/nxatel_meet"]; 
    return {
        nxatel_call: state["features/nxatel_call"],
        _roomName: getConferenceNameForTitle(state),
        _meetDetail,
        extension_list,
        default_lobby,
        invitation_list: state["jistimeet_settings"].invitation_list,
    };
}

export default reactReduxConnect(_mapStateToProps)(translate(DeviceSelection));
